(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    class ContactFormNewsletter extends HTMLElement {
    connectedCallback() {
      const mainForm = document.getElementById(this.dataset.formId);
      const checkbox = document.getElementById('ContactForm-newsletter');
      const emailInput = document.getElementById('ContactForm-email');
      const newsletterForm = this.querySelector('form');
      const newsletterEmailInput = this.querySelector('input[name="contact[email]"]');

      if (!mainForm || !checkbox || !newsletterForm || !newsletterEmailInput) return;

      mainForm.addEventListener('submit', () => {
        if (checkbox.checked && emailInput.value) {
          newsletterEmailInput.value = emailInput.value;
          navigator.sendBeacon(newsletterForm.action, new FormData(newsletterForm));
        }
      });
    }
  }

  if (!customElements.get('contact-form-newsletter')) {
    customElements.define('contact-form-newsletter', ContactFormNewsletter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["manifesto-reveal"] && !Shopify.designMode) return;
  try {
    class ManifestoReveal extends HTMLElement {
    connectedCallback() {
      this.target = this.querySelector('[data-reveal-text]');
      if (!this.target || this.hasAttribute('data-initialized')) return;
      this.setAttribute('data-initialized', 'true');

      // Reduced-motion visitors get the static text as-is (also enforced in CSS as a fallback).
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Starting points for the feel; adjust these (or the block's "Reveal duration" /
      // "Stagger between lines" settings in the theme editor) to tune the pacing.
      this.durationMs = Number(this.dataset.durationMs) || 1000;
      this.staggerMs = Number(this.dataset.staggerMs) || 200;

      this.lines = Array.from(this.target.children);
      if (!this.lines.length) return;

      this.triggered = false;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (this.triggered || !entries[0]?.isIntersecting) return;
          this.triggered = true;
          this.observer.disconnect();
          this.#reveal();
        },
        { threshold: 0.4 }
      );
      this.observer.observe(this);
    }

    #reveal() {
      this.lines.forEach((line, index) => {
        setTimeout(() => {
          line.classList.add('manifesto-reveal__line--revealed');
        }, index * this.staggerMs);
      });
    }
  }

  if (!customElements.get('manifesto-reveal')) {
    customElements.define('manifesto-reveal', ManifestoReveal);
  }
  } catch(e) { console.error(e); }
})();

})();
